export function formatTimezoneWithOffset(timezone?: string | null): string {
  if (!timezone) {
    return 'Not captured';
  }

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'longOffset',
    });

    const offsetPart = formatter
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;

    if (!offsetPart) {
      return timezone;
    }

    const normalizedOffset = offsetPart === 'GMT'
      ? 'UTC+00:00'
      : offsetPart.replace('GMT', 'UTC');

    return `${timezone} (${normalizedOffset})`;
  } catch {
    return timezone;
  }
}
